import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {DefaultSmileIdDetail, SmileIdDetail, SmileIdMode} from "../../model/kamonal-model";

@Component({
  selector: 'app-kamona-smile-id',
  templateUrl: './kamona-smile-id.component.html',
  styleUrls: ['./kamona-smile-id.component.scss']
})
export class KamonaSmileIdComponent implements OnInit, OnDestroy {
	@Input() mode: SmileIdMode = SmileIdMode.Liveness_Images;
	@Output() emitImage = new EventEmitter();
	@Output() emitReviewScreenHTMLElement = new EventEmitter<HTMLElement>();
	@Output() emitCameraScreenHTMLElement = new EventEmitter<HTMLElement>();
	@Output() emitRequestScreenHTMLElement = new EventEmitter<HTMLElement>();
	@Output() emitSelectSelfieBtnHTMLElement = new EventEmitter<HTMLElement>();
	@Output() emitRestartImageCaptureBtnHTMLElement = new EventEmitter<HTMLElement>();
	@Output() emitRequestCameraAccessBtnHTMLElement = new EventEmitter<HTMLElement>();
	@Output() emitStartImageCaptureBtnHTMLElement = new EventEmitter<HTMLElement>();
	app;

	constructor() { }

	ngOnInit(): void {
		this.initialize();
	}

	ngOnDestroy() {
		// TODO: remove this temporary fix when smile id fixes camera closing
		if (this.app) {
			if (this.app._stream) {
				this.app._stopVideoStream(this.app._stream);
			}
			if (this.app._IDStream) {
				this.app._stopIDVideoStream(this.app._IDStream);
			}
		}
	}

	initialize(){
		const app = document.querySelector('smart-camera-web');
		if(!app){return;}
		this.setAppElement(app);
		this.setHTMLElement(app);
		this.setListeners(app);
		this.addAttribute(this.app);
	}

	setHTMLElement(app: Element){
		this.setRequestCameraAccessBtnHTMLElement(app);
		this.setStartImageCaptureHTMLElement(app);
		this.setRequestScreenHTMLElement(app);
		this.setSelectSelfieBtnHTMLElement(app);
		this.setRestartImageCaptureBtnHTMLElement(app);
	}

	setListeners(app: Element){
		this.setCameraScreenListener(app);
		this.setImagesComputedListener(app);
		this.setReviewScreenListener(app);
	}

	setAppElement(app: Element){
		this.app = app;
	}

	setImagesComputedListener(app: Element){
		app.addEventListener('imagesComputed', async (e: any) => {
			this.emitImage.emit(this.getImage(e?.detail));
		});
	};

	setRequestCameraAccessBtnHTMLElement(app: Element){
		const requestCameraAccessBtn = app?.shadowRoot?.getElementById('request-camera-access');
		if(!requestCameraAccessBtn){return;}
		this.emitRequestCameraAccessBtnHTMLElement.emit(requestCameraAccessBtn);
	}

	setSelectSelfieBtnHTMLElement(app: Element){
		const selectSelfieBtn = app?.shadowRoot?.getElementById('select-selfie');
		if(!selectSelfieBtn){return;}
		this.emitSelectSelfieBtnHTMLElement.emit(selectSelfieBtn);
	}

	setRestartImageCaptureBtnHTMLElement(app: Element){
		const restartImageCaptureBtn = app?.shadowRoot?.getElementById('restart-image-capture');
		if(!restartImageCaptureBtn){return;}
		this.emitRestartImageCaptureBtnHTMLElement.emit(restartImageCaptureBtn);
	}

	setRequestScreenHTMLElement(app: Element){
		const requestScreen = app?.shadowRoot?.getElementById('request-screen');
		if(!requestScreen){return;}
		this.emitRequestScreenHTMLElement.emit(requestScreen);
	}


	setReviewScreenListener(app: Element){
		const reviewScreen = app?.shadowRoot?.getElementById('review-screen');
		this.isElementVisible(reviewScreen, (visible) =>{
			if(visible)
			this.emitReviewScreenHTMLElement.emit(reviewScreen);
		})
	}

	setStartImageCaptureHTMLElement(app: Element){
		const startImageCaptureBtn = app?.shadowRoot?.getElementById('start-image-capture');
		if(!startImageCaptureBtn){return;}
		this.emitStartImageCaptureBtnHTMLElement.emit(startImageCaptureBtn);
	}

	setCameraScreenListener(app: Element){
		const cameraScreen = app?.shadowRoot?.getElementById('camera-screen');
		this.isElementVisible(cameraScreen, (visible) =>{
			if(visible)
			this.emitCameraScreenHTMLElement.emit(cameraScreen);
		})
	}

	isElementVisible = function (element, callback) {
		const options = {
			root: document.documentElement,
		};
		const observer = new IntersectionObserver((entries, observer) => {
			entries.forEach((entry) => {
				callback(entry.intersectionRatio > 0);
			});
		}, options);
		observer.observe(element);
	};

	addAttribute(app: Element){
		this.addIdCardAttribute(app);
		this.addUploadDocumentAttribute(app);
	}

	addIdCardAttribute(app: Element){
		if(this.mode === SmileIdMode.ID_Card_Photo)
			app?.setAttribute('capture-id', `back`);
	}

	addUploadDocumentAttribute(app: Element){
		if(this.mode === SmileIdMode.Document_Capture)
			app?.setAttribute('document-capture-modes', `upload`);
	}

	getImage(smileIdDetail: SmileIdDetail){
		return smileIdDetail?.images ?? DefaultSmileIdDetail;
	}


}
